export const extractUrlsFromFieldValues = (fieldValues: any) =>
    Object.values(fieldValues).map((entry: any) => entry.url);
export const getEmptyLink = () => ({ url: '' });
